<template>
  <a
    :href="link"
    target="_blank"
    rel="noopener noreferrer"
    class="whatsapp-suporte"
    title="Falar com o suporte no WhatsApp"
    aria-label="Falar com o suporte no WhatsApp"
  >
    <v-icon color="#fff" large>mdi-whatsapp</v-icon>
  </a>
</template>

<script>
const NUMERO = "558694437915";

export default {
  name: "EWhatsappSuporte",
  computed: {
    link() {
      return `https://api.whatsapp.com/send/?phone=${NUMERO}&type=phone_number&app_absent=0`;
    },
  },
};
</script>

<style scoped>
.whatsapp-suporte {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1000;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: #25d366;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);
  text-decoration: none;
  transition: transform 0.2s;
}
.whatsapp-suporte:hover {
  transform: scale(1.1);
}
@media print {
  .whatsapp-suporte {
    display: none;
  }
}
</style>
